export default {
  total: 'total',
  headers: {
    //Accept: 'application/json',
   // 'Content-Type': 'application/json',
  },
  updateMethod: 'PUT',
  arrayFormat: 'brackets',
};
